import { Component, Renderer2, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { CustomizerService } from './shared/service/customizer.service';
import { NavigationEnd, Router } from '@angular/router';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public url: any;
  title = 'Fit Up';
  public layoutType: string = 'dark'
  firebaseConfig = {
    apiKey: "AIzaSyA5Yih8hxRP2YPzMzPzZvkSCs4yqYnZ4HY",
    authDomain: "fitupxp.firebaseapp.com",
    projectId: "fitupxp",
    storageBucket: "fitupxp.appspot.com",
    messagingSenderId: "476309164881",
    appId: "1:476309164881:web:79e861c62da516c0ca3970",
    measurementId: "G-W2N8S1XZMB"
  };

  constructor(public customize: CustomizerService, private router: Router, private _renderer2: Renderer2, @Inject(DOCUMENT) private _document: Document) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.url = event.url;
      }
    });
  }

  public ngOnInit() {
    let script = this._renderer2.createElement('script');
    script.src = `/assets/tilt.js`;
    this._renderer2.appendChild(this._document.body, script);
    const app = initializeApp(this.firebaseConfig);
    const analytics = getAnalytics(app);
  }
  
  customizeLayoutVersion(val: any) {
    this.customize.setLayoutVersion(val)
    this.layoutType = val
  }

  customizeLayoutType(val: any) {
    this.customize.setLayoutType(val)
    this.layoutType = val
  }
}
